<ng-container *ngIf="appInitService.isBootstrapped$ | async">
  <div class="patient-layout">
    <app-patient-header></app-patient-header>

    <main class="patient-main">
      <router-outlet></router-outlet>
    </main>

    <app-patient-footer></app-patient-footer>
  </div>
</ng-container>
